import React from "react";
import { HomeFeaturedContentTemplate } from "themes/application/home/components";
class HomeFeaturedContent extends React.Component {
    render() {
        return <HomeFeaturedContentTemplate {...this.props} />;
    }
}

export default HomeFeaturedContent;
